import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { merge, interval } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ProcessDataSource } from 'src/app/services/process.datasource';
import { ProcessService } from 'src/app/services/process.service';
import { UserService } from 'src/app/services/user.service';
import { YearService } from 'src/app/services/year.service';
import { environment } from "../../../../environments/environment";
import { MatDialog } from '@angular/material/dialog';
import { AvisBulkDownloadDialogComponent } from '../../dialogs/avis-bulk-download-dialog/avis-bulk-download-dialog.component';
@Component({
  selector: "rdf-stat-table-all-dec-activity",
  templateUrl: "./stat-table-all-dec.component.html",
  styleUrls: ["./stat-table-all-dec.component.css"],
})
export class StatTableAllDecComponent implements OnInit {
  dataSource: ProcessDataSource
  @Input() displayedColumns;
  @Output() onDownloadStatistics = new EventEmitter<any>();
  user: any;
  name: string;
  avisBulkPreparing = false;
  avisBulkReady = false;
  avisBulkJobId = null;
  avisBulkFiles = [];
  avisBulkPollingSub: any;
  avisBulkFailed = false;
  avisBulkError = null;
  objectFilter = { internal: false, allSubmittedDec: true };
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(public yearService: YearService,
    public translate: TranslateService,
    private router: Router,
    public dialog: MatDialog,
    public processService: ProcessService, public userService: UserService, public spinner: NgxSpinnerService) { 
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user
      this.dataSource = new ProcessDataSource(this.processService)
      setTimeout(() => {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
  
        merge(this.sort.sortChange, this.paginator.page)
          .pipe(
            tap(() => this.loadProcessPage())
          )
          .subscribe();
      }, 1000);
    })
  }

  ngOnInit() {
    this.checkCurrentAvisBulkJob();
  }

  checkCurrentAvisBulkJob() {
    this.processService.getCurrentAvisBulkJob().subscribe((res) => {
      if (!res || !res.id) {
        return;
      }
  
      this.avisBulkJobId = res.id;
      this.avisBulkFiles = res.files || [];
  
      if (res.status === 'PREPARING') {
        this.avisBulkPreparing = true;
        this.avisBulkReady = false;
        this.startAvisBulkPolling();
      }
  
      if (res.status === 'READY') {
        this.avisBulkPreparing = false;
        this.avisBulkReady = true;
      }
  
      if (res.status === 'FAILED') {
        this.resetAvisBulkState();
      }
    });
  }

  advancedSearch(filter) {
    this.spinner.show()
    this.objectFilter = filter
    this.objectFilter['allSubmittedDec'] = true;
    this.resetAvisBulkState();
    this.loadProcessPage()
  }

  resetAvisBulkState() {
    if (this.avisBulkPollingSub) {
      this.avisBulkPollingSub.unsubscribe();
    }
  
    this.avisBulkPreparing = false;
    this.avisBulkReady = false;
    this.avisBulkJobId = null;
    this.avisBulkFiles = [];
    this.avisBulkFailed = false;
    this.avisBulkError = null;
  }

  downloadAvisBulk() {
    const dialogRef = this.dialog.open(AvisBulkDownloadDialogComponent, {
      width: '600px',
      data: {
        jobId: this.avisBulkJobId,
        files: this.avisBulkFiles
      }
    });
  
    dialogRef.afterClosed().subscribe(() => {
      if (this.avisBulkJobId) {
        this.processService.deleteAvisBulk(this.avisBulkJobId).subscribe(() => {
          this.resetAvisBulkState();
        });
      }
    });
  }

  prepareAvisBulk() {
    this.avisBulkPreparing = true;
    this.avisBulkReady = false;
  
    this.processService.prepareAvisBulk(this.objectFilter).subscribe(
      (res) => {
        this.avisBulkJobId = res.id;
        this.startAvisBulkPolling();
      },
      () => {
        this.avisBulkPreparing = false;
        this.avisBulkReady = false;
      }
    );
  }

  startAvisBulkPolling() {
    if (this.avisBulkPollingSub) {
      this.avisBulkPollingSub.unsubscribe();
    }
  
    this.avisBulkPollingSub = interval(10000).subscribe(() => {
      this.processService.getAvisBulkStatus(this.avisBulkJobId).subscribe((res) => {
        if (!res) {
          this.resetAvisBulkState();
          return;
        }
  
        if (res.status === 'READY') {
          this.avisBulkPreparing = false;
          this.avisBulkReady = true;
          this.avisBulkFiles = res.files || [];
          this.avisBulkPollingSub.unsubscribe();
        }
  
        if (res.status === 'FAILED') {
          this.avisBulkPreparing = false;
          this.avisBulkReady = false;
          this.avisBulkFailed = true;
          this.avisBulkError = res.error;
          this.avisBulkPollingSub.unsubscribe();
        }
      });
    });
  }

  resetTable() {
    const jobId = this.avisBulkJobId;
  
    if (jobId) {
      this.processService.deleteAvisBulk(jobId).subscribe();
    }
  
    this.resetAvisBulkState();
    this.objectFilter = { internal: false, allSubmittedDec: true };
  
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
  
    if (this.dataSource) {
      this.dataSource.emptyData();
    }
  }

  loadProcessPage() {
    this.spinner.show();
    this.dataSource.loadAllSubmittedDecList(
      this.sort.direction, 
      this.sort.active, 
      this.paginator.pageIndex, 
      this.paginator.pageSize, 
      this.objectFilter, 
      this.spinner
    );
  }
}
